export const LEGAL_IMPRINT_LEGAL_NOTICE: string = `

### Impressum

<!-- for (const addressLine of context.company.address) { -->
<!--= addressLine -->
<!-- } -->

Telefon: Auf Anfrage
E-Mail: <!--= context.company.mail -->

Geschäftsführer
<!-- for (const director of context.company.directors) { -->
<!--= director -->
<!-- } -->

Registergericht: <!--= context.company.court -->
Registernummer: <!--= context.company.courtNumber -->

Umsatzsteuer-Identifikationsnummer (USt-ID):  <!--= context.company.vat -->

#### Unsere rechtlichen Hinweise verstehen

Der Abschnitt “Impressum” enthält wichtige Informationen zu unserer Website, darunter Angaben zum Unternehmen, Kontaktinformationen und rechtliche Verpflichtungen. Er sorgt für Transparenz, Einhaltung geltender Gesetze und erleichtert eine effektive Kommunikation. Bitte lesen Sie diesen Abschnitt, um mehr über unsere rechtliche Identität und Verantwortlichkeiten zu erfahren.
`;
